export default __webpack_public_path__ + "static/media/report-error.e1cf2c8e.svg";